import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M12.03 8.5c0-1.38-1.12-2.5-2.5-2.5s-2.5 1.12-2.5 2.5S8.15 11 9.53 11s2.5-1.12 2.5-2.5zm-4 0c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5z',
    'M12.53 17h-2.16c1.53-1.89 4.66-6 4.66-8.37.04-3.07-2.42-5.59-5.49-5.63h-.01C6.46 3.03 4 5.55 4.03 8.62v.01c0 2.37 3.13 6.48 4.66 8.37H6.53c-.28 0-.5.22-.5.5s.22.5.5.5h6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5zm-7.5-8.37C5 6.11 7.01 4.04 9.53 4c2.52.04 4.53 2.11 4.5 4.63 0 1.37-1.7 4.37-4.43 7.73l-.07.08-.06-.07C6.73 13 5.03 10 5.03 8.63z',
  ],
  height: 20,
  width: 20,
});
